/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Contact_Reactivation_RestrictedInputs */

const en_case_contact_reactivation_restricted = /** @type {(inputs: Case_Contact_Reactivation_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An inactive contact with this phone number already exists in this case. Only admins and managers can reactivate it.`)
};

const pt_br2_case_contact_reactivation_restricted = /** @type {(inputs: Case_Contact_Reactivation_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já existe um contato inativo com este número de telefone neste caso. Somente administradores e gestores podem reativá-lo.`)
};

/**
* | output |
* | --- |
* | "An inactive contact with this phone number already exists in this case. Only admins and managers can reactivate it." |
*
* @param {Case_Contact_Reactivation_RestrictedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_reactivation_restricted = /** @type {((inputs?: Case_Contact_Reactivation_RestrictedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Reactivation_RestrictedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_reactivation_restricted(inputs)
	return pt_br2_case_contact_reactivation_restricted(inputs)
});